import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ActiveErrorsStore } from '@store';
import { InformationPopupPage } from '../../../../shared/components/information-popup/information-popup.model';

@Component({
  selector: 'app-guided-troubleshooting',
  templateUrl: './guided-troubleshooting.component.html',
  styleUrls: ['./guided-troubleshooting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidedTroubleshootingComponent {
  readonly InformationPopupPage = InformationPopupPage;

  constructor(public activeErrorsStore: ActiveErrorsStore) {}
}
